import { render, staticRenderFns } from "./App.vue?vue&type=template&id=0ec63d86&scoped=true"
import script from "./App.ts?vue&type=script&lang=ts&external"
export * from "./App.ts?vue&type=script&lang=ts&external"
import style0 from "./App.vue?vue&type=style&index=0&id=0ec63d86&prod&scoped=true&lang=scss"
import style1 from "./App.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec63d86",
  null
  
)

export default component.exports